module.exports = __webpack_public_path__ + "static/daneshmand-logo-9f1945475c34235cba6aded290bfd4f5.jpg";